import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalFirestoreTimestamp,
} from '../shared/schema'

export const schema = z.object({
  sectionId: z.string(),
  assignmentId: z.string(),
  roomId: z.string(),
  userId: z.string(),
  reviewerUserId: z.string(),
  review: z.record(z.string(), z.number()),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    sectionId: '',
    assignmentId: '',
    roomId: '',
    userId: '',
    reviewerUserId: '',
    review: {},
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export interface FirestoreRoomStateUPRPeerReview extends z.infer<
  typeof schema
> {}
